import { HttpInterceptorFn } from '@angular/common/http';
import { HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SecurityAlertComponent } from '../components/security-alert/security-alert.component';
import { Observable, tap } from 'rxjs';

export const httpSecurityInterceptor: HttpInterceptorFn = (
	request: HttpRequest<any>,
	next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
	const dialog = inject(MatDialog)

	return next(request).pipe(
		tap({
			error: (error: HttpErrorResponse) => {
				if (error.status >= 400 && error.status < 500) {
					console.log('----response----')
					console.error('status code:', error.status)
					console.error(error.message)
					console.log('--- end of response---')

					setTimeout(() => {
						dialog.open(SecurityAlertComponent, {
							position: { top: '40px' },
							hasBackdrop: true,
							panelClass: 'no-dialog-borders',
							disableClose: true,
							data: { code: error.status }
						})
					}, 10)
				}
			}
		})
	)
}
